// File that contains the global JS code for all pages
import SmoothScroll from "smooth-scroll";

export default function main() {

  const global = () => {
    import('./modules/contact.js')
      .then(( contact ) => { contact.init() })
      .catch( error => { console.log( error ) });

    import('./modules/navigation.js')
      .then(( navigation ) => { navigation.init() })
      .catch( error => { console.log( error ) });

    import('./modules/languageswitcher.js')
      .then(( languageswitcher ) => { languageswitcher.init() })
      .catch( error => { console.log( error ) });
  }

  const sections = () => {
    if (document.querySelector('section.pricing')){
      import('./modules/pricing.js')
        .then(( pricing ) => { pricing.init() })
        .catch( error => { console.log( error ) });
    }
    if (document.querySelector('section.testimonials')){
      import('./modules/testimonials.js')
        .then(( testimonials ) => { testimonials.init() })
        .catch( error => { console.log( error ) });
    }
    if (document.querySelector('section.customer-cases')){
      import('./modules/customerCases.js')
        .then(( customerCases ) => { customerCases.init() })
        .catch( error => { console.log( error ) });
    }
    if (document.querySelector('section.solutions__container')){
      import('./modules/solutions.js')
        .then(( solutions ) => { solutions.init() })
        .catch( error => { console.log( error ) });
    }
    if (document.querySelector('section.avantages__container')){
      import('./modules/avantages.js')
        .then(( avantages ) => { avantages.init() })
        .catch( error => { console.log( error ) });
    }
    if (document.querySelector('section.home-header')){
      import('./modules/homeHeader.js')
        .then(( homeHeader ) => { homeHeader.init() })
        .catch( error => { console.log( error ) });
    }
    if (document.querySelector('section.partners-introduction')){
      import('./modules/partners.js')
        .then(( partners ) => { partners.init() })
        .catch( error => { console.log( error ) });
    }
    if (document.querySelector('section.overview__container')){
      import('./modules/overview.js')
        .then(( overview ) => { overview.init() })
        .catch( error => { console.log( error ) });
    }
    if (document.querySelector('section.asset-viewer__container')){
      import('./modules/assetViewer.js')
        .then(( assetViewer ) => { assetViewer.init() })
        .catch( error => { console.log( error ) });
    }
  }

  const scroll = () => {
    new SmoothScroll('a[href*="#"]', {
      speed: 300,
      offset: (to, from) => { return (from instanceof Node && from.dataset.offset) ? from.dataset.offset : 0; }
    });

    // DEBUG IE11/EDGE SMOOTH-SCROLL
    let isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
    if (!isIE11 && /Edge/.test(navigator.userAgent) === true || navigator.userAgent.match(/Trident\/7\./) === true) {
      import('./modules/smoothScrollCustom.js')
        .then(( SmoothScrollCustom ) => { SmoothScrollCustom.init(document, 120, 10) })
        .catch( error => { console.log( error ) });
    }
  }

  const init = () => {
    global();
    scroll();
    sections();
  }

  init();
};

